import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const CalendarContainer = styled.div<{ $hasFooter?: boolean }>`
  width: ${pxToRem(360)};
  max-width: calc(100vw - ${pxToRem(32)});
  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)};
  box-shadow: ${({ theme, $hasFooter }) =>
    $hasFooter ? theme.shadows.md : "none"};

  .react-datepicker {
    width: 100%;
    overflow: hidden;
    border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.inkBorder};
    border-radius: ${({ theme, $hasFooter }) =>
      $hasFooter
        ? `${pxToRem(theme.radii.lg)} ${pxToRem(theme.radii.lg)} 0 0`
        : pxToRem(theme.radii.lg)};
    background: ${({ theme }) => theme.colors.white};
    box-shadow: ${({ theme, $hasFooter }) =>
      $hasFooter ? "none" : theme.shadows.md};
    font-family: inherit;
    font-size: ${pxToRem(16)};
  }

  .react-datepicker__month-container {
    float: none;
    width: 100%;
    padding: ${pxToRem(16)};
  }

  .react-datepicker__header {
    padding: 0;
    border-bottom: 0;
    background: ${({ theme }) => theme.colors.white};
  }

  .react-datepicker__current-month {
    margin: 0 0 ${pxToRem(14)};
    color: ${({ theme }) => theme.colors.ink};
    font-size: ${pxToRem(20)};
    font-weight: 600;
    line-height: 1.3;
    text-transform: capitalize;
  }

  .react-datepicker__day-names {
    display: grid;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    width: 100%;
    margin: 0 0 ${pxToRem(8)};
  }

  .react-datepicker__day-name {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: ${pxToRem(24)};
    margin: 0;
    color: ${({ theme }) => theme.colors.inkMuted};
    font-size: ${pxToRem(14)};
    font-weight: 500;
    line-height: 1;
  }

  .react-datepicker__month {
    width: 100%;
    margin: 0;
  }

  .react-datepicker__week {
    display: grid;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    width: 100%;
  }

  .react-datepicker__day {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: ${pxToRem(40)};
    margin: 0;
    border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
    color: ${({ theme }) => theme.colors.ink};
    font-size: ${pxToRem(16)};
    font-weight: 400;
    line-height: 1;
    transition:
      background-color 0.15s ease,
      color 0.15s ease,
      box-shadow 0.15s ease;
  }

  .react-datepicker__day--outside-month {
    color: ${({ theme }) => theme.colors.inkMuted};
  }

  .react-datepicker__day--disabled {
    color: ${({ theme }) => theme.colors.grayDisabled};
    cursor: not-allowed;
  }

  .react-datepicker__day:hover:not(.react-datepicker__day--disabled):not(.react-datepicker__day--selected):not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end):not(.react-datepicker__day--selecting-range-start):not(.react-datepicker__day--selecting-range-end) {
    border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
    background: ${({ theme }) => theme.colors.brandSubtle};
    color: ${({ theme }) => theme.colors.brandDark};
  }

  .react-datepicker__day--keyboard-selected {
    background: ${({ theme }) => theme.colors.brandSubtle};
    color: ${({ theme }) => theme.colors.brand};
  }

  .react-datepicker__day--selected {
    border-radius: ${({ theme }) => pxToRem(theme.radii.md)} !important;
    background: ${({ theme }) => theme.colors.brand} !important;
    color: ${({ theme }) => theme.colors.white} !important;
    font-weight: 500;
  }

  .react-datepicker__day--today:not(.react-datepicker__day--selected):not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {
    background: transparent;
    box-shadow: inset 0 0 0 ${pxToRem(1)} ${({ theme }) => theme.colors.brand};
    color: ${({ theme }) => theme.colors.brand};
    font-weight: 600;
  }

  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range {
    border-radius: 0 !important;
    background: ${({ theme }) => theme.colors.brandSoft};
    color: ${({ theme }) => theme.colors.brandDark} !important;
  }

  .react-datepicker__day--range-start,
  .react-datepicker__day--selecting-range-start {
    border-radius: ${({ theme }) => pxToRem(theme.radii.md)} 0 0
      ${({ theme }) => pxToRem(theme.radii.md)} !important;
    background: ${({ theme }) => theme.colors.brand} !important;
    color: ${({ theme }) => theme.colors.white} !important;
    font-weight: 500;
  }

  .react-datepicker__day--range-end,
  .react-datepicker__day--selecting-range-end {
    border-radius: 0 ${({ theme }) => pxToRem(theme.radii.md)}
      ${({ theme }) => pxToRem(theme.radii.md)} 0 !important;
    background: ${({ theme }) => theme.colors.brand} !important;
    color: ${({ theme }) => theme.colors.white} !important;
    font-weight: 500;
  }

  .react-datepicker__day--range-start.react-datepicker__day--range-end,
  .react-datepicker__day--selecting-range-start.react-datepicker__day--selecting-range-end {
    border-radius: ${({ theme }) => pxToRem(theme.radii.md)} !important;
  }

  .react-datepicker__navigation {
    top: ${pxToRem(12)};
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${pxToRem(32)};
    height: ${pxToRem(32)};
    border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
    background: transparent;
    transition: background-color 0.15s ease;
  }

  .react-datepicker__navigation:hover {
    background: ${({ theme }) => theme.colors.brandSubtle};
  }

  .react-datepicker__navigation--previous {
    left: ${pxToRem(12)};
  }

  .react-datepicker__navigation--next {
    right: ${pxToRem(12)};
  }

  .react-datepicker__navigation-icon::before {
    top: ${pxToRem(8)};
    width: ${pxToRem(8)};
    height: ${pxToRem(8)};
    border-color: ${({ theme }) => theme.colors.inkMuted};
    border-width: ${pxToRem(2)} ${pxToRem(2)} 0 0;
  }
`;

export const CalendarFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin-top: ${pxToRem(-1)};
  padding: ${pxToRem(10)} ${pxToRem(14)};
  border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.inkBorder};
  border-top: 0;
  border-radius: 0 0 ${({ theme }) => pxToRem(theme.radii.lg)}
    ${({ theme }) => pxToRem(theme.radii.lg)};
  background: ${({ theme }) => theme.colors.white};
`;